<template>
    <v-dialog v-model="getViewMap" width="55%" height="55%" persistent>
        <v-card>
            <v-card-title>View Map</v-card-title>
            <v-divider></v-divider>
            <v-row no-gutters>
                <v-col cols="3">
                    <v-text-field label="Map Name" v-model="mapDetails.mapName" outlined class="ma-4"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field label="Floor Number" v-model="mapDetails.mapFloor" outlined
                        class="ma-2 my-4"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-textarea label="Map Description" v-model="mapDetails.speech" outlined class="ma-4"></v-textarea>
                </v-col>
                <v-col cols="12">
                    <v-img :src="'https://cms.mdcourts.arsconnect.com' + mapDetails.mapImage.url" contain
                        height="500"></v-img>
                </v-col>
            </v-row>
            <v-card-actions class="justify-end">
                * Please contact Advanced Robot Solutions to add new map or update an existing map.
                <!-- <v-btn width="100" class="ma-3" color="primary" @click="editMap()"><v-icon class="mr-2"
                        small>mdi-pencil</v-icon>Edit</v-btn>
                <v-btn width="100" color="error"><v-icon class="mr-2" small>mdi-delete</v-icon>Delete</v-btn>
                 -->
                <v-btn width="100" class="ma-3" @click="$store.commit('setViewMap', false)" color="error"><v-icon
                        class="mr-2" small>mdi-close</v-icon> Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: "viewMap",
    data() {
        return {
            mapDetails: {
                mapName: "",
                speech: "",
                mapFloor: "",
                mapImage: { url: "" },
                displayPosition: 0,
                kioskLocationCode: "",
                isCourtroom: false,
                mapAlias: "",
                courtroomType: ""
            }
        }
    },
    computed: {
        ...mapGetters(["getViewMap", "getSelectedMap"]),
    },
    watch: {
        getSelectedMap(newVal) {
            console.log('Selected Map: ', newVal)
            if (this.getSelectedMap != {}) {
                this.mapDetails = newVal
            }
        }
    },
    mounted() {
        // console.log('Selected Map: ', this.getSelectedMap)
        if (this.getSelectedMap != {}) {
            this.mapDetails = this.getSelectedMap
        }
    }
}
</script>